<template>
  <div>
    <router-view v-slot="{ Component }">
      <keep-alive :include="keepAliveArr">
        <component :is="Component" />
      </keep-alive>
    </router-view>
  </div>
</template>

<script setup>
import { handleLoginState } from '@/utils/common';
import { computed, onMounted } from 'vue';
import store from '@/store';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

NProgress.configure({ showSpinner: false });
NProgress.start();
onMounted(() => {
  NProgress.done();
});

const keepAliveArr = computed(() => {
  console.log('store.state.keepAliveArr: ', store.state.keepAliveArr);
  return store.state.keepAliveArr;
});

document.addEventListener('visibilitychange', () => { // 浏览器切换事件
  if (document.visibilityState === 'visible') { // visible 回到当前tab
    handleLoginState();
  }
});
</script>

<!--<style lang="less">-->
<!--@import '~/ant-design-vue/dist/antd';-->
<!--</style>-->
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
